export class Schedule {
    id : string;
    serviceName : string;
    moduleName : string;
    pathSchedule : string;
    segundo : string;
    minuto : string;
    hora : string;
    dia : string;
    mes: string;
    diaSemana : string;
    ativo : boolean;
    _ativo : string;

    constructor() {}
}